// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { __extends } from "tslib";
import React from "react";
import { SeverityLevel } from "@microsoft/applicationinsights-core-js";
var AppInsightsErrorBoundary = /** @class */ (function (_super) {
    __extends(AppInsightsErrorBoundary, _super);
    function AppInsightsErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
        return _this;
    }
    AppInsightsErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ hasError: true, error: error, errorInfo: errorInfo });
        this.props.appInsights.trackException({
            error: error,
            exception: error,
            severityLevel: SeverityLevel.Error,
            properties: errorInfo
        });
    };
    AppInsightsErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, error = _a.error, errorInfo = _a.errorInfo;
        var _b = this.props, onError = _b.onError, children = _b.children;
        if (hasError) {
            return React.createElement(onError, { error: error, errorInfo: errorInfo });
        }
        return children;
    };
    return AppInsightsErrorBoundary;
}(React.Component));
export default AppInsightsErrorBoundary;
//# sourceMappingURL=AppInsightsErrorBoundary.js.map